
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Calendar, CalendarDays } from 'lucide-react';

interface TimeRangeFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export const TimeRangeFilter = ({ value, onChange }: TimeRangeFilterProps) => {
  const timeRanges = [
    { value: '3months', label: 'Last 3 Months', icon: Calendar },
    { value: '6months', label: 'Last 6 Months', icon: Calendar },
    { value: '1year', label: 'Last Year', icon: CalendarDays },
    { value: '2years', label: 'Last 2 Years', icon: CalendarDays },
    { value: '3years', label: 'Last 3 Years', icon: CalendarDays },
    { value: '5years', label: 'Last 5 Years', icon: CalendarDays },
    { value: 'all', label: 'All Time', icon: CalendarDays }
  ];

  return (
    <div className="flex items-center gap-2">
      <Calendar className="h-4 w-4 text-gray-500" />
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select time range" />
        </SelectTrigger>
        <SelectContent>
          {timeRanges.map((range) => (
            <SelectItem key={range.value} value={range.value}>
              <div className="flex items-center gap-2">
                <range.icon className="h-4 w-4" />
                {range.label}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
